export default "__VITE_ASSET__d7653031__"